import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BusinessGroupModel } from 'src/app/ViewModel/BusinessGroupModel';
import { RestApiService } from '../rest-api.service';

@Injectable({
	providedIn: 'root'
})
export class ProjectMemberLinkService {

	private projectBusinessGroupUrl = 'Organization/GetOrganizationAgainstProject';
	private selectedMemberListUrl = 'ProjectMembersLink/GetMembersAgainstProjectBusinessGroup';
	private postProjectMemberLinkUrl = 'ProjectMembersLink/PostProjectMembertDetails';

	constructor(public restApiService: RestApiService,) { }

	getProjectBusinessGroup(projectId: number): Observable<BusinessGroupModel[]> {
		return this.restApiService.new_POST(this.projectBusinessGroupUrl, { projectId });
	}

	getSelectedMemberList(projectId: number, groupId: number | null | string) {
		return this.restApiService.new_POST(this.selectedMemberListUrl, { projectId, groupId });
	}

	postProjectMemberLink(reqData: any) {
		return this.restApiService.new_POST(this.postProjectMemberLinkUrl, reqData);
	}

}
